const Constantes = {
  api_url: process.env.REACT_APP_API_URL,
  tam_ficheros: process.env.REACT_APP_TAM_SUBIDA_FICHEROS_MB,
}

export default Constantes
